export const AUTH_START = "AUTH_START";
export const AUTH_END = "AUTH_END";
export const AUTH_FAIL = "AUTH_FAIL";
export const AUTH_SUCCESS = "AUTH_SUCCESS";
export const CLEAN_UP = "CLEAN_UP";
export const SIGN_OUT = "SIGN_OUT";
